import React from 'react';
import DialogContent from '@mui/material/DialogContent';
import { bgColors } from '../utils/bgColor';
import {BootstrapDialog,BootstrapDialogTitle} from './Form/CustomDialog'
import {closeNavDetailDialog} from "../../redux/actions/controlbuttonaction"
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import Directionicons from '../layout/Directionicons';
import { useDispatch, useSelector } from 'react-redux';
import { sidebarwith } from './Form/Const';
import { stylemaster } from '../layout/styleConst';
export default function NavigationDetails(props) {
  const {open,data} = props
  const dispatch = useDispatch()
  // const navData = useSelector(state => state.mapreducer.navroutedata)
  const centrecord = useSelector(state => state.mapreducer.mapcentrecord)
  const selectedvillage = useSelector(state => state.mapreducer.selectedvillage)
  return (
    // <div  style = {{maxWidth:'300px'}}>
    // <>
      <BootstrapDialog
        hideBackdrop
        onClose={() => {dispatch(closeNavDetailDialog)}}
        aria-labelledby="customized-dialog-title"
        open={open}
        scroll="paper"
        sx={{
            "& .MuiDialog-container": {
               alignItems: "flex-start",
               "& .MuiPaper-root": {
                marginTop:'5rem',
                marginLeft:'0.25rem',
                width: sidebarwith,
                maxHeight:"400px",
                    
                    },
            },
         }}
        
        PaperProps={{sx: {position:'fixed' , top:0, left:0} ,style:{borderRadius: 10,
        background:bgColors.sidpanel_grey,
        color:bgColors.grey_300,
        opacity:0.8
        }}}
      >
      <BootstrapDialogTitle 
      onClose={() => {dispatch(closeNavDetailDialog)}}
      >
       {/* Navigation details */}
       <Grid container display={'flex'}>
      
       <Typography style ={stylemaster.Typography_header}>
       distance in Km: {(data.distance/1000).toFixed(2)}
       </Typography>
       <Typography style ={stylemaster.Typography_body}> 
       destination: {selectedvillage}
       </Typography>
     
       <Typography style ={stylemaster.Typography_body}>
       destination longitude: {centrecord.longitude.toFixed(5)}
      
       </Typography>
       <Typography style ={stylemaster.Typography_body}>
       destination Latitude: {centrecord.latitude.toFixed(5)}
       </Typography>
       </Grid>
        </BootstrapDialogTitle>
        <DialogContent dividers>
         
          {/* <CardHeader>
          distance in Km: {(data.distance/1000).toFixed(2)}
         </CardHeader> */}
         
          <Grid container  spacing ={1}>
          {data.steps!==undefined && 
          <Grid item xs={12}>
            <Typography component="h2" style ={{marginLeft:'0.5rem',fontSize: "0.8rem"}} key ={'nav_title'}>
          
            </Typography>
            {data.steps.map((d, index) => 
            <div style = {{display:'flex', direction:'row'}} key ={`${index}_seasoncrop`}>
              <List>
            <Typography style ={{marginLeft:'0.5rem',fontSize: "0.8rem"}} key ={index}>
            {Directionicons(d.maneuver.instruction)}
            {d.maneuver.instruction} for {(d.distance/1000).toFixed(2)} km
            duration {(d.duration/3600).toFixed(2)} hrs
            </Typography>
            </List>
            </div>
            )}
          
          </Grid>
          }
        </Grid>
        
   
      </DialogContent>
      </BootstrapDialog>
  
      // </>
  );
}